

export function getValue(sensor, field) {
    if (sensor.last_received_data) {
        return sensor.last_received_data[field];
    }
}